import { TypedDocumentNode, gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  CancelImportLineup,
  CancelImportLineupVariables,
} from './__generated__/useCancelImportLineup.graphql';

const CANCEL_IMPORT_LINEUP_MUTATION = gql`
  mutation CancelImportLineup($input: declineSo5LineupImportsBatchInput!) {
    declineSo5LineupImportsBatch(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<CancelImportLineup, CancelImportLineupVariables>;

export const useCancelImportLineup = (id?: string | null) => {
  const [cancelImportLineup] = useMutation(CANCEL_IMPORT_LINEUP_MUTATION, {
    variables: {
      input: {
        batchId: id!,
      },
    },
    showErrorsWithSnackNotification: true,
  });

  return cancelImportLineup;
};
